import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStaffSnake = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 19C16.1046 19 17 18.1046 17 17C17 15.8954 16.1046 15 15 15H10C8.89543 15 8 14.1046 8 13C8 12.2597 8.4022 11.6134 9 11.2676M12 19H10M15 11H17C18.6569 11 20 9.65685 20 8C20 6.34315 18.6569 5 17 5H8M12 3V21M8 5H6C4.89543 5 4 5.89543 4 7C4 8.10457 4.89543 9 6 9C7.10457 9 8 8.10457 8 7V6.5V5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStaffSnake;
